export const categories = [
    {
        id: 1,
        img: `${require("./assets/images/men.webp")}`,
        title: "MEN",
    },
    {
        id: 2,
        img: `${require("./assets/images/women.webp")}`,
        title: "WOMEN",
    },
    {
        id: 3,
        img: `${require("./assets/images/kids.webp")}`,
        title: "KIDS",
    },
];

export const products = [
    {
        id: 1,
        img: `${require("./assets/images/shoe1.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 4,
        price: 8295,
        gender: "men",
    },
    {
        id: 2,
        img: `${require("./assets/images/shoe2.jfif")}`,
        title: "Nike",
        details: "Nike Dunk High Retro SE",
        rating: 3,
        price: 10295,
        gender: "men",
    },
    {
        id: 3,
        img: `${require("./assets/images/shoe3.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 2,
        price: 9695,
        gender: "women",
    },
    {
        id: 4,
        img: `${require("./assets/images/shoe1.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 5,
        price: 8295,
        gender: "women",
    },
    {
        id: 5,
        img: `${require("./assets/images/shoe2.jfif")}`,
        title: "Nike",
        details: "Nike Dunk High Retro SE",
        rating: 5,
        price: 10295,
        gender: "men",
    },
    {
        id: 6,
        img: `${require("./assets/images/shoe3.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 3,
        price: 9695,
        gender: "men",
    },
    {
        id: 7,
        img: `${require("./assets/images/shoe1.jfif")}`,
        title: "Nike",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 1,
        price: 8295,
        gender: "women",
    },
    {
        id: 8,
        img: `${require("./assets/images/shoe2.jfif")}`,
        title: "Vans",
        details: "Nike Dunk High Retro SE",
        rating: 2,
        price: 10295,
        gender: "kids",
    },
    {
        id: 9,
        img: `${require("./assets/images/shoe3.jfif")}`,
        title: "Vans",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 3,
        price: 9695,
        gender: "kids",
    },
    {
        id: 10,
        img: `${require("./assets/images/shoe2.jfif")}`,
        title: "Puma",
        details: "Nike Dunk High Retro SE",
        rating: 4,
        price: 10295,
        gender: "men",
    },
    {
        id: 11,
        img: `${require("./assets/images/shoe3.jfif")}`,
        title: "Puma",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 4,
        price: 9695,
        gender: "men",
    },
    {
        id: 12,
        img: `${require("./assets/images/shoe1.jfif")}`,
        title: "Adidas",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 5,
        price: 8295,
        gender: "women",
    },
    {
        id: 13,
        img: `${require("./assets/images/shoe2.jfif")}`,
        title: "Adidas",
        details: "Nike Dunk High Retro SE",
        rating: 2,
        price: 10295,
        gender: "kids",
    },
    {
        id: 14,
        img: `${require("./assets/images/shoe3.jfif")}`,
        title: "Adidas",
        details: "Nike Air Force 1 '07 LV8'",
        rating: 3,
        price: 9695,
        gender: "kids",
    },
];
